const mutations = {
  'UPDATE_GLOBAL_PROFILE': (state, payload) => {
    state.profile = payload.profile;
    state.remain = payload.profile.remain;
    state.isPost = payload.profile.isPost;
    state.subscription = payload.profile.subscription;
    state.upstream_proxy = payload.profile.upstream_proxy;
  },
  'UPDATE_SUBSCRIPTION': (state, payload) => {
    state.subscription = payload.value;
  },
  'UPDATE_UPSTREAM_PROXY': (state, payload) => {
    state.upstream_proxy = payload.value;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js